import { render, staticRenderFns } from "./HomeNotesRead.vue?vue&type=template&id=e4f73d44&scoped=true"
import script from "./HomeNotesRead.vue?vue&type=script&lang=js"
export * from "./HomeNotesRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f73d44",
  null
  
)

export default component.exports